import { AutoMappingCombiningTargetFormationBase } from './base/auto-mapping-combining-target-formation-base';

export class AutoMappingCombiningTargetFormation extends AutoMappingCombiningTargetFormationBase { }